module.exports = __webpack_public_path__ + "static/media/login.d6abaec1.png";